var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-popover',_vm._g(_vm._b({},'v-popover',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_vm._v(" "),_c('template',{slot:"popover"},[_vm._t("popover")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }